<template>
    <v-container>
      <v-layout>
        <v-toolbar>
          <v-flex v-if="hgAuthenticated" class="report-menu">
            <hg-report-menu :hg-current-page="hgCurrentPage"/>
          </v-flex>
          <v-flex v-if="hgAuthenticated" class="main-menu">
            <hg-main-menu :hg-user="hgUser" />
          </v-flex>
        </v-toolbar>
      </v-layout>
    </v-container>
</template>

<script>
import MainMenu from './Menu/MainMenu.vue';
import ReportMenu from './Menu/ReportMenu.vue';

export default {
  props: {
    hgAuthenticated: {
      type: Boolean,
      required: true,
    },
    hgCurrentPage: {
      required: false,
      type: String,
    },
    hgUser: {
      required: false,
      type: Object,
    },
  },
  components: {
    'hg-main-menu': MainMenu,
    'hg-report-menu': ReportMenu,
  },
};
</script>

<style lang="scss" scoped>
.theme--light .v-toolbar {
  background-color: transparent;
  border: none;
  box-shadow: none;

  .main-menu {
    flex: 0 0 161px;

    div:first-child {
      text-align: right;
    }
  }

  .report-menu {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
